// extracted by mini-css-extract-plugin
export default {"Drawer":"aXaGceC7","ContentRoot":"WI0gQaOW"};